import React from 'react';

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import RefreshButton from '../../components/ui/RefreshButton';
import { Badge } from '../../components/ui/badge';

import { Users, UserPlus, Shield, AlertTriangle, Calendar, Key, Settings, Bell, TrendingUp, Clock, Activity, BarChart3, FileText, Globe, Zap, Target, Building, Building2, Briefcase, CreditCard, CheckCircle, Eye, ChevronRight, Database, FolderOpen, Layers, Calculator, BookOpen, Video, DollarSign, Package, Handshake, Receipt, Mail, User, FileSignature, Home, HardDrive, Gift, Megaphone, Landmark, QrCode, Award, History, Recycle } from 'lucide-react';

import '../../styles/print-institutional.css';

// Import des composants Phase 3

import CodeQualityScoreWidget from '../../components/CodeQualityScoreWidget';
import PdfCachePurgeWidget from '../../components/PdfCachePurgeWidget';
import DiskMonitoringWidget from '../../components/DiskMonitoringWidget';
import BrevoDomainWidget from '../../components/BrevoDomainWidget';
import NAFDistributionWidget from '../../components/NAFDistributionWidget';

// Import des nouveaux composants Pro

// FTPERegistreAdherentsAdmin: module SUPPRIMÉ (26/05/2026).

import QualificationsPendingWidget from '../../components/QualificationsPendingWidget';

const _BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Onglets du dashboard
const _TABS = [
  { id: 'overview', label: 'Vue d\'ensemble', icon: BarChart3 },
  { id: 'validation-manuelle', label: 'Majorations personnalisées', icon: Award },
  { id: 'kpi-dashboard', label: '📈 KPIs', icon: TrendingUp },
  { id: 'analytics', label: '📊 Analytics', icon: TrendingUp },
  { id: 'announcements', label: '📢 Annonces', icon: Megaphone },
  { id: 'ftpe-adhesions', label: '🏢 Adhésions FTPE', icon: Building },
  { id: 'ftpe-virements', label: '🏦 Validation Virements', icon: Landmark },
  { id: 'registres-custom', label: '📚 Registres Custom', icon: BookOpen },
  { id: 'released-accounts', label: '♻️ Comptes libérés', icon: History },
  { id: 'funnels-events', label: '🎯 Funnels & Events', icon: Activity },
  { id: 'conventions-paiements', label: '💳 Conventions Payantes', icon: CreditCard },
  { id: 'communications-section', label: 'COMMUNICATION & ALERTES', isSeparator: true },
  { id: 'alertes-virements', label: '🔔 Alertes Virements', icon: Bell },
  { id: 'alertes-echeances', label: 'Alertes Echeances', icon: Mail },
  { id: 'email-tracking', label: 'Suivi Emails', icon: Mail },
  { id: 'email-preview', label: '✉️ Aperçu Emails', icon: Mail },
  { id: 'demandes-partenariat', label: '🤝 Partenariats', icon: Handshake },
  { id: 'demandes-remises', label: '♻️ Demandes remises', icon: Recycle },
  { id: 'partenariats-section', label: 'COMPTES, PLANS & CRÉDITS', isSeparator: true },
  { id: 'identifiants', label: '🔑 Identifiants', icon: Key },
  { id: 'plans', label: '📦 Plans', icon: Package },
  { id: 'subscription-types', label: '🏷️ Types de souscription', icon: Layers },
  { id: 'factures-plans', label: '💼 Factures Plans (PADH-)', icon: FileText },
  { id: 'propositions-signees', label: '✍️ Propositions signées', icon: FileSignature },
  { id: 'registre-pcs', label: '📜 Registre PCS (ESS)', icon: Award },
  { id: 'seuils-echelonnement', label: '💳 Seuils SEPA échelonnés', icon: CreditCard },
  { id: 'registre-fiscal', label: '⚖️ Registre Fiscal', icon: FileText },
  { id: 'credits', label: '🪙 Crédits', icon: CreditCard },
  { id: 'credits-guide-cms', label: '📖 Guide Crédits (CMS)', icon: BookOpen },
  { id: 'audit-credits', label: '📋 Audit Crédits', icon: Shield },
  { id: 'bonus-programmes', label: '🎁 Bonus Programmés', icon: Gift },
  { id: 'promotions', label: '⚡ Promos Flash', icon: Zap },
  { id: 'gestion-membres', label: 'Création Membres', icon: UserPlus },
  { id: 'comptes-test', label: '🧪 Comptes de test', icon: UserPlus, externalRoute: '/admin/comptes-test' },
  { id: 'export-stats', label: '📊 Export & Stats', icon: TrendingUp },
  { id: 'ged-section', label: 'GED & DOCUMENTATION', isSeparator: true },
  { id: 'backups', label: '💾 Backups', icon: HardDrive },
  { id: 'rgpd-zip-shares', label: '🛡️ Audit RGPD ZIP', icon: Shield },
  { id: 'rgpd-unified', label: '🛡️ Registre RGPD Unifié', icon: Shield },
  { id: 'ged-ess', label: 'GED ESS', icon: FolderOpen },
  { id: 'ged-statistiques', label: 'Statistiques GED', icon: BarChart3 },
  { id: 'cartographie', label: 'Cartographie', icon: Globe },
  { id: 'collections', label: 'Collections', icon: Database },
  { id: 'categories', label: 'Catégories', icon: FolderOpen },
  { id: 'nomenclatures', label: 'Nomenclatures', icon: BookOpen },
  { id: 'simulateurs-separator', label: '🎯 SIMULATEURS MAÎTRES', isSeparator: true },
  { id: 'simulateur-batico', label: '🧮 BATICO Calculateur', icon: Calculator },
  { id: 'simulateur-dos', label: 'DOS-DOMIUM', icon: Home },
  { id: 'cockpit-ccmi', label: '🏗️ Cockpit CCMI', icon: Building2, externalRoute: '/admin/ccmi-dashboard' },
  { id: 'gestion-financiere-domium', label: '💰 Gestion Financière DOMIUM', icon: CreditCard },
  { id: 'batico-config-advanced', label: '🚀 Config BATICO Avancée', icon: Settings },
  { id: 'coopers-experts', label: "COOPER'S & EXPERTS", icon: Building },
  { id: 'suivi-section', label: 'SUIVI & TRAÇABILITÉ', isSeparator: true },
  { id: 'rappels-dashboard', label: "🔔 Suivi Rappels", icon: Bell },
  { id: 'factures-recus', label: "Factures et reçus ESS", icon: Receipt },
  { id: 'suivi-rcds', label: 'Suivi RCDS', icon: Shield },
  { id: 'suivi-dos-domium', label: 'Suivi DOS DOMIUM', icon: Building2 },
  { id: 'tarifs-demandes', label: 'Tarifs Leads', icon: DollarSign },
  { id: 'conventions', label: 'Conventions Partenariat', icon: FileText },
  { id: 'videos', label: 'Vidéos', icon: Video },
  { id: 'operations-section', label: 'OPÉRATIONS & SYSTÈME', isSeparator: true },
  { id: 'export-import', label: 'Export/Import', icon: Database },
  { id: 'alerts', label: 'Alertes', icon: AlertTriangle },
  { id: 'agenda', label: 'Agenda', icon: Calendar },
  { id: 'roles', label: 'Rôles', icon: Shield },
  { id: 'assignments', label: 'Assignations', icon: Users },
  { id: 'messagerie', label: 'Messagerie', icon: Mail },
  { id: 'config-emails-clients', label: 'Config Emails Clients', icon: Mail },
  { id: 'journal-emails', label: 'Journal Emails', icon: Mail },
  { id: 'registre-qr', label: 'Registre QR Codes', icon: QrCode },
  { id: 'code-health', label: '⚙️ Code Health', icon: Activity },
  { id: 'nav-config', label: '🧭 Navigation (onglets)', icon: Layers, externalRoute: '/admin/navigation-config' },
  { id: 'frontoffice-nav', label: '🧭 Menus front-office', icon: Layers },
  { id: 'frontoffice-footer', label: '🦶 Pied de page', icon: Layers },
  { id: 'profil', label: 'Mon Profil', icon: User }
];

export default function SuperAdminOverview({ ctx }) {
  const { allUsers, assignments, dashboardStats, handleRefreshOverview, kpiMensuel, loading: loading, navigate, refreshing, setActiveTab, t } = ctx;
  return (
    <div className="space-y-6">
      {/* En-tête avec résumé */}
      <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 rounded-2xl p-6 text-white shadow-xl">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
          <div>
            <h2 className="text-2xl font-bold flex items-center gap-3">
              <Zap className="h-7 w-7" />
              Tableau de Bord Super Admin
            </h2>
            <p className="text-blue-100 mt-1">
              Vue d&apos;ensemble de l&apos;activité de la plateforme O&apos;SCOP
            </p>
          </div>
          <div className="flex items-center gap-3">
            <Badge className="bg-slate-800 text-white border-slate-700 px-4 py-2 font-semibold shadow-md">
              <Activity className="h-4 w-4 mr-2" />
              Temps réel
            </Badge>
            <RefreshButton
              onRefresh={handleRefreshOverview}
              loading={refreshing}
              successMessage="Tableau de bord actualisé"
              variant="light"
              testId="super-admin-refresh-btn"
            />
          </div>
        </div>
        
        {/* Mini stats dans le header */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
                <Users className="h-5 w-5" />
              </div>
              <div>
                <p className="text-2xl font-bold">{allUsers.members.length + allUsers.coopers.length + allUsers.experts.length}</p>
                <p className="text-xs text-blue-100">{t('super_admin_dashboard.total_users', 'Utilisateurs totaux')}</p>
              </div>
            </div>
          </div>
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
                <TrendingUp className="h-5 w-5" />
              </div>
              <div>
                <p className="text-2xl font-bold">{assignments.length}</p>
                <p className="text-xs text-blue-100">{t('super_admin_dashboard.active_assignments', 'Assignations actives')}</p>
              </div>
            </div>
          </div>
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
                <CheckCircle className="h-5 w-5" />
              </div>
              <div>
                <p className="text-2xl font-bold">{dashboardStats?.validated_today || 0}</p>
                <p className="text-xs text-blue-100">{t('super_admin_dashboard.validated_today', 'Validés aujourd\'hui')}</p>
              </div>
            </div>
          </div>
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
                <Bell className="h-5 w-5" />
              </div>
              <div>
                <p className="text-2xl font-bold">{dashboardStats?.unread_notifications || 0}</p>
                <p className="text-xs text-blue-100">{t('super_admin_dashboard.notifications', 'Notifications')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Code Quality Score Widget (P3) */}
      <CodeQualityScoreWidget onViewDetails={() => setActiveTab('code-health')} />

      {/* Disk Monitoring Widget (Vague 21) */}
      <DiskMonitoringWidget />

      {/* Brevo Email Domain Widget (Vague 21 — vérification DKIM/SPF/DMARC) */}
      <BrevoDomainWidget />

      {/* PDF Cache Purge Widget (P2 — purge R2 + disque pour bénéficier des dernières améliorations templates) */}
      <PdfCachePurgeWidget />

      {/* Répartition NAF (P2 — visibilité business des secteurs majoritaires) */}
      <NAFDistributionWidget />

      {/* Validation manuelle qualifications (Lot B — Couches 3 & 4 BATICO) */}
      <QualificationsPendingWidget onOpen={() => setActiveTab('validation-manuelle')} />

      {/* KPI business du mois (visibilité directe Super Admin) */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="kpi-mensuel-grid">
        <Card className="bg-gradient-to-br from-emerald-600 to-emerald-700 text-white border-0 shadow-lg hover:shadow-xl transition-all" data-testid="kpi-devis-signes-card">
          <CardContent className="pt-6 pb-6">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center">
                <FileSignature className="h-7 w-7 text-white" />
              </div>
              <div>
                <div className="text-4xl font-bold" data-testid="kpi-devis-signes-value">
                  {kpiMensuel?.devis_signes_ce_mois ?? 0}
                </div>
                <div className="text-sm text-emerald-50 font-medium">Devis signés ce mois</div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-gradient-to-br from-indigo-600 to-indigo-700 text-white border-0 shadow-lg hover:shadow-xl transition-all" data-testid="kpi-encaisse-card">
          <CardContent className="pt-6 pb-6">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center">
                <TrendingUp className="h-7 w-7 text-white" />
              </div>
              <div>
                <div className="text-4xl font-bold" data-testid="kpi-encaisse-value">
                  {(kpiMensuel?.encaisse_ce_mois ?? 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}
                </div>
                <div className="text-sm text-indigo-50 font-medium">Encaissé ce mois</div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Alertes critiques */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <Card className="bg-gradient-to-br from-red-50 to-white border-red-200 hover:shadow-lg transition-all cursor-pointer" onClick={() => setActiveTab('alerts')}>
          <CardContent className="pt-5">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-2xl bg-red-100 flex items-center justify-center">
                <AlertTriangle className="h-7 w-7 text-red-600" />
              </div>
              <div>
                <div className="text-3xl font-bold text-red-700">
                  {dashboardStats?.expiring_7_days || 0}
                </div>
                <div className="text-sm text-red-600 font-medium">{t('super_admin_dashboard.expires_7d', 'Expire sous 7j')}</div>
              </div>
            </div>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-orange-50 to-white border-orange-200 hover:shadow-lg transition-all cursor-pointer" onClick={() => setActiveTab('alerts')}>
          <CardContent className="pt-5">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-2xl bg-orange-100 flex items-center justify-center">
                <Clock className="h-7 w-7 text-orange-600" />
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-700">
                  {dashboardStats?.expiring_30_days || 0}
                </div>
                <div className="text-sm text-orange-600 font-medium">{t('super_admin_dashboard.expires_30d', 'Expire sous 30j')}</div>
              </div>
            </div>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-yellow-50 to-white border-yellow-200 hover:shadow-lg transition-all">
          <CardContent className="pt-5">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-2xl bg-yellow-100 flex items-center justify-center">
                <CreditCard className="h-7 w-7 text-yellow-600" />
              </div>
              <div>
                <div className="text-3xl font-bold text-yellow-700">
                  {dashboardStats?.pending_payments || 0}
                </div>
                <div className="text-sm text-yellow-600 font-medium">{t('super_admin_dashboard.pending_payments', 'Paiements en attente')}</div>
              </div>
            </div>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-blue-50 to-white border-blue-200 hover:shadow-lg transition-all">
          <CardContent className="pt-5">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-2xl bg-blue-100 flex items-center justify-center">
                <Users className="h-7 w-7 text-blue-600" />
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-700">
                  {dashboardStats?.pending_members || 0}
                </div>
                <div className="text-sm text-blue-600 font-medium">{t('super_admin_dashboard.pending_members', 'Membres en attente')}</div>
              </div>
            </div>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-purple-50 to-white border-purple-200 hover:shadow-lg transition-all cursor-pointer" onClick={() => navigate('/dashboard-unified')}>
          <CardContent className="pt-5">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-2xl bg-purple-100 flex items-center justify-center">
                <Briefcase className="h-7 w-7 text-purple-600" />
              </div>
              <div>
                <div className="text-3xl font-bold text-purple-700">
                  {dashboardStats?.pending_experts || 0}
                </div>
                <div className="text-sm text-purple-600 font-medium">EXPERTS en attente</div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Statistiques détaillées et actions */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Répartition utilisateurs */}
        <Card className="lg:col-span-2">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Users className="h-5 w-5 text-blue-600" />
              Répartition des Utilisateurs
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-3 gap-4">
              <div className="text-center p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-2xl border border-green-200">
                <div className="w-16 h-16 mx-auto mb-3 rounded-2xl bg-green-200 flex items-center justify-center">
                  <Users className="h-8 w-8 text-green-700" />
                </div>
                <p className="text-4xl font-bold text-green-700">{allUsers.members.length}</p>
                <p className="text-sm text-green-600 font-medium mt-1">{t('super_admin_dashboard.members', 'Membres')}</p>
                <div className="mt-3 pt-3 border-t border-green-200">
                  <p className="text-xs text-green-600">
                    <span className="font-semibold">{dashboardStats?.active_members || 0}</span> actifs
                  </p>
                </div>
              </div>
              
              <div className="text-center p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl border border-purple-200">
                <div className="w-16 h-16 mx-auto mb-3 rounded-2xl bg-purple-200 flex items-center justify-center">
                  <Building className="h-8 w-8 text-purple-700" />
                </div>
                <p className="text-4xl font-bold text-purple-700">{allUsers.coopers.length}</p>
                <p className="text-sm text-purple-600 font-medium mt-1">COOPER&apos;S</p>
                <div className="mt-3 pt-3 border-t border-purple-200">
                  <p className="text-xs text-purple-600">
                    <span className="font-semibold">{dashboardStats?.active_coopers || 0}</span> actifs
                  </p>
                </div>
              </div>
              
              <div className="text-center p-6 bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl border border-orange-200">
                <div className="w-16 h-16 mx-auto mb-3 rounded-2xl bg-orange-200 flex items-center justify-center">
                  <Briefcase className="h-8 w-8 text-orange-700" />
                </div>
                <p className="text-4xl font-bold text-orange-700">{allUsers.experts.length}</p>
                <p className="text-sm text-orange-600 font-medium mt-1">EXPERTS</p>
                <div className="mt-3 pt-3 border-t border-orange-200">
                  <p className="text-xs text-orange-600">
                    <span className="font-semibold">{dashboardStats?.active_experts || 0}</span> actifs
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
        
        {/* Actions rapides */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Zap className="h-5 w-5 text-orange-500" />
              Actions Rapides
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <Button 
              variant="outline" 
              className="w-full justify-between h-auto py-3 hover:bg-red-50 hover:border-red-200 group"
              onClick={() => setActiveTab('alerts')}
            >
              <span className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center group-hover:bg-red-200 transition-colors">
                  <AlertTriangle className="h-5 w-5 text-red-600" />
                </div>
                <span className="font-medium">{t('super_admin_dashboard.view_alerts', 'Voir les alertes')}</span>
              </span>
              <ChevronRight className="h-5 w-5 text-gray-400" />
            </Button>
            
            <Button 
              variant="outline" 
              className="w-full justify-between h-auto py-3 hover:bg-blue-50 hover:border-blue-200 group"
              onClick={() => setActiveTab('cartographie')}
            >
              <span className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                  <Globe className="h-5 w-5 text-blue-600" />
                </div>
                <span className="font-medium">{t('super_admin_dashboard.cartography', 'Cartographie')}</span>
              </span>
              <ChevronRight className="h-5 w-5 text-gray-400" />
            </Button>
            
            <Button 
              variant="outline" 
              className="w-full justify-between h-auto py-3 hover:bg-green-50 hover:border-green-200 group"
              onClick={() => setActiveTab('agenda')}
            >
              <span className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center group-hover:bg-green-200 transition-colors">
                  <Calendar className="h-5 w-5 text-green-600" />
                </div>
                <span className="font-medium">{t('super_admin_dashboard.open_agenda', 'Ouvrir l\'agenda')}</span>
              </span>
              <ChevronRight className="h-5 w-5 text-gray-400" />
            </Button>
            
            <Button 
              variant="outline" 
              className="w-full justify-between h-auto py-3 hover:bg-purple-50 hover:border-purple-200 group"
              onClick={() => setActiveTab('roles')}
            >
              <span className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center group-hover:bg-purple-200 transition-colors">
                  <Shield className="h-5 w-5 text-purple-600" />
                </div>
                <span className="font-medium">Gérer les rôles</span>
              </span>
              <ChevronRight className="h-5 w-5 text-gray-400" />
            </Button>
            
            <Button 
              className="w-full justify-between h-auto py-3 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700"
              onClick={() => setActiveTab('assignments')}
            >
              <span className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
                  <UserPlus className="h-5 w-5 text-white" />
                </div>
                <span className="font-medium">{t('super_admin_dashboard.new_assignment', 'Nouvelle assignation')}</span>
              </span>
              <ChevronRight className="h-5 w-5 text-white/70" />
            </Button>
          </CardContent>
        </Card>
      </div>

      {/* Aperçu Cartographie */}
      <Card className="overflow-hidden">
        <CardHeader className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Globe className="h-6 w-6" />
              <div>
                <CardTitle className="text-white">{t('super_admin_dashboard.cartographic_overview', 'Aperçu Cartographique')}</CardTitle>
                <CardDescription className="text-blue-100">
                  Dommages, réparations et EXPERTS sur le territoire
                </CardDescription>
              </div>
            </div>
            <Button 
              variant="outline" 
              className="bg-white/10 border-white/30 text-white hover:bg-white/20"
              onClick={() => setActiveTab('cartographie')}
            >
              <Eye className="h-4 w-4 mr-2" />
              Voir la carte complète
            </Button>
          </div>
        </CardHeader>
        <CardContent className="p-0">
          <div className="grid grid-cols-4 divide-x">
            <div className="p-6 text-center hover:bg-red-50 transition-colors cursor-pointer" onClick={() => setActiveTab('cartographie')}>
              <div className="w-12 h-12 mx-auto mb-2 rounded-full bg-red-100 flex items-center justify-center">
                <AlertTriangle className="h-6 w-6 text-red-600" />
              </div>
              <p className="text-2xl font-bold text-red-700">{dashboardStats?.dommages_actifs || 12}</p>
              <p className="text-sm text-gray-600">{t('super_admin_dashboard.active_damages', 'Dommages actifs')}</p>
            </div>
            <div className="p-6 text-center hover:bg-purple-50 transition-colors cursor-pointer" onClick={() => setActiveTab('cartographie')}>
              <div className="w-12 h-12 mx-auto mb-2 rounded-full bg-purple-100 flex items-center justify-center">
                <Target className="h-6 w-6 text-purple-600" />
              </div>
              <p className="text-2xl font-bold text-purple-700">{dashboardStats?.reparations_en_cours || 8}</p>
              <p className="text-sm text-gray-600">Réparations en cours</p>
            </div>
            <div className="p-6 text-center hover:bg-blue-50 transition-colors cursor-pointer" onClick={() => setActiveTab('cartographie')}>
              <div className="w-12 h-12 mx-auto mb-2 rounded-full bg-blue-100 flex items-center justify-center">
                <Users className="h-6 w-6 text-blue-600" />
              </div>
              <p className="text-2xl font-bold text-blue-700">{dashboardStats?.experts_assignes || allUsers.experts.length}</p>
              <p className="text-sm text-gray-600">EXPERTS assignés</p>
            </div>
            <div className="p-6 text-center hover:bg-green-50 transition-colors cursor-pointer" onClick={() => setActiveTab('cartographie')}>
              <div className="w-12 h-12 mx-auto mb-2 rounded-full bg-green-100 flex items-center justify-center">
                <Shield className="h-6 w-6 text-green-600" />
              </div>
              <p className="text-2xl font-bold text-green-700">{dashboardStats?.rcd_annuels || 45}</p>
              <p className="text-sm text-gray-600">RCDS annuels actifs</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
